import type { Role, User } from '../models/user';
import { api, PANEL_API } from './api-client';

export interface UserCreateInput {
  username: string;
  password: string;
  role: Role;
  fullName?: string;
  email?: string;
}

class UserService {
  async list(): Promise<User[]> {
    const res = await api.get<{ users: User[] }>(`${PANEL_API}/users`);
    return res.users;
  }

  async create(input: UserCreateInput): Promise<User> {
    return api.post<User>(`${PANEL_API}/users`, input);
  }

  async setRole(username: string, role: Role): Promise<User> {
    return api.put<User>(`${PANEL_API}/users/${encodeURIComponent(username)}/role`, { role });
  }

  async resetPassword(username: string, password: string): Promise<void> {
    await api.put(`${PANEL_API}/users/${encodeURIComponent(username)}/password`, { password });
  }

  async remove(username: string): Promise<void> {
    await api.delete(`${PANEL_API}/users/${encodeURIComponent(username)}`);
  }

  /** Kendi parolanı değiştir (mevcut parola doğrulanır). */
  async changeOwnPassword(current: string, next: string): Promise<void> {
    await api.put(`${PANEL_API}/me/password`, { current, next });
  }
}

export const users = new UserService();

/** Panelde şifre üretici: okunur, karışık 14 karakter. */
export function generatePassword(): string {
  const alphabet = 'abcdefghjkmnpqrstuvwxyzABCDEFGHJKMNPQRSTUVWXYZ23456789-!';
  const bytes = new Uint8Array(14);
  crypto.getRandomValues(bytes);
  return [...bytes].map((b) => alphabet[b % alphabet.length]).join('');
}
